import Tasks from 'APP/Tasks';
import { IGroupCounterView } from 'APP/model/counter/counterModel.types';
import { createGroupAndInvite as apiCreateGroupAndInvite } from 'APP/model/group/groupModel';
import { ICreateGroupRequest, IPersonalizedGroup } from 'APP/model/group/groupModel.types';
import { spaceAnalytics } from 'APP/packages/analytics/analytics';
import { Group } from 'APP/store/Groups/Group';
import Entities from 'STORE';

async function request(
  data: ICreateGroupRequest
): Promise<null | { group: IPersonalizedGroup; counter: IGroupCounterView }> {
  try {
    // SERVER IS SENSITIVE TO DEFAULT VALUES, DON'T CHANGE THEM
    const response = await apiCreateGroupAndInvite({
      name: (data.name || '').trim() || null,
      description: data.description || '',
      type: data.type,
      members: data.members,
      admins: data.admins || [],
      avatarUrl: data.avatarUrl || null,
      categoryId: data.categoryId,
      deepLinkAlias: data.deepLinkAlias || '', // generate new deep link
      donationUrl: data.donationUrl || '',
      spaceId: data.spaceId || null,
    });

    if (response?.personalizedGroup?.groupResponse) {
      return {
        group: response.personalizedGroup,
        counter: response.groupCounter,
      };
    }
  } catch (error) {
    return null;
  }

  return null;
}

function trackGroupCreateEvent(group: Group): void {
  if (!group.spaceId) {
    return;
  }

  const space = Entities.spacesStore.getById(group.spaceId);

  if (space) {
    group.isChatGroup
      ? spaceAnalytics.trackSpaceGroupCreated(space.id, space.type, group.id, group.type)
      : spaceAnalytics.trackSpaceChannelCreated(space.id, space.type, group.id, group.type);
  }
}

export async function createGroupAndInvite(
  data: ICreateGroupRequest,
  shouldBeSetAsActive = true
): Promise<Group | null> {
  const response = await request(data);

  if (!response) {
    return null;
  }

  const { group, counter } = response;

  const opponent = group.opponent || group.botOpponent;
  if (opponent) {
    Entities.usersStore.add([opponent]);
  }

  Entities.GroupsStore.merge([group]);

  const newGroup = Entities.GroupsStore.getGroupById(group.groupResponse.id);
  if (!newGroup) {
    return null;
  }

  if (shouldBeSetAsActive) {
    await Tasks.group.setActiveGroup({ groupId: newGroup.id });
  }
  await Tasks.group.addCounters([counter]);

  trackGroupCreateEvent(newGroup);

  return newGroup;
}
